module.exports = __webpack_public_path__ + "img/index_title.d7e86dd3.png";